import React from 'react';
import styles from './styles.scoped.css';
import { Select as SelectMantine, Text } from '@mantine/core';
import { analytics } from '../../../utils/firebase';
import { propTypes } from './constants';
import { logEvent } from 'firebase/analytics';
function Select(props) {
  const {
    className,
    data,
    eventName,
    input = {},
    inputProps,
    onChangeSelect,
    onClearFields,
    onBlur,
    searchable,
    valueForm,
    onSearchChange,
    required,
    showErrorWithoutTouched,
    meta = {},
    ...restProps
  } = props;

  const { touched, error } = meta;

  const classes = [styles.root, className].filter(Boolean).join(' ');
  const value = input.value || valueForm;

  const onSelectChange = (event) => {
    logEvent(analytics, eventName, {
      value: event,
    });

    onChangeSelect && onChangeSelect(event);
    input.onChange && input.onChange(event);
    onClearFields && onClearFields();
  };
  const onSelectBlur = (event) => {
    onBlur && onBlur(event);
    input.onBlur && input.onBlur();
  };

  return (
    <div>
      <SelectMantine
        {...restProps}
        {...inputProps}
        className={classes}
        data={data || []}
        error={Boolean(touched && error)}
        onBlur={onSelectBlur}
        onChange={onSelectChange}
        onKeyUp={onSearchChange}
        searchable={searchable}
        styles={{ label: { fontWeight: 600, fontSize: 16 } }}
        value={value}
        withAsterisk={required}
        // withCheckIcon={false}
      />
      {touched && error && <span className={styles.error}>{error}</span>}
      {error && showErrorWithoutTouched && (
        <span className={styles.error}>{error}</span>
      )}
      {inputProps?.info && (
        <Text c="#1D2939" fz={14}>
          {inputProps?.info}
        </Text>
      )}
    </div>
  );
}

Select.propTypes = { ...propTypes };

Select.defaultProps = {
  className: '',
  data: [],
  eventName: '',
  input: {},
  inputProps: {},
  meta: {},
  onChangeSelect: () => {},
  onClearFields: () => {},
  onBlur: () => {},
  onSearchChange: () => {},
  searchable: false,
  required: false,
  valueForm: undefined,
};

export default Select;
